import { cn } from 'lib/utils'
import { Button } from 'primitives/button'
import type { ComponentProps } from 'react'
import { useCallback } from 'react'

export type SuggestionsProps = ComponentProps<'div'>

export const Suggestions = ({ className, children, ...props }: SuggestionsProps) => (
  <div className={cn('flex flex-col gap-2 w-full', className)} {...props}>
    {children}
  </div>
)

export type SuggestionProps = Omit<ComponentProps<typeof Button>, 'onClick'> & {
  suggestion: string
  onClick?: (suggestion: string) => void
}

export const Suggestion = ({
  suggestion,
  onClick,
  className,
  variant = 'outline',
  size = 'sm',
  children,
  ...props
}: SuggestionProps) => {
  const handleClick = useCallback(() => {
    onClick?.(suggestion)
  }, [onClick, suggestion])

  return (
    <Button
      className={cn('cursor-pointer justify-start text-left text-s-400 h-auto py-2', className)}
      onClick={handleClick}
      size={size}
      type="button"
      variant={variant}
      {...props}
    >
      {children || suggestion}
    </Button>
  )
}
